import useProfileQuery from './useProfileQuery'

const Profile = () => {
  const { data, loading, error } = useProfileQuery()

  return loading ? 'Loading...' : error ? `Error: ${error}` : `Data: ${data}`
}

export default Profile
